import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { datadogLogs, Datacenter } from '@datadog/browser-logs';

import './i18n';

const BUILD_TARGETS = [
  {
    name: 'SSO',
    path: './components/Sso.jsx',
  },
  {
    name: 'RESETPSW',
    path: './components/pages/ResetPwd/ResetPwd.jsx',
  },
  {
    name: 'TWOFACTOR',
    path: './components/pages/TwoFactor/TwoFactor.jsx',
  },
];

if (process.env.REACT_APP_ENV) {
  datadogLogs.init({
    clientToken: 'pubf770d58b42cb33085bf9606ddc121a4d',
    datacenter: Datacenter.US,
    forwardErrorsToLogs: true,
    sampleRate: 100,
  });
  datadogLogs.addLoggerGlobalContext('app', 'login-app');
  datadogLogs.addLoggerGlobalContext('env', process.env.REACT_APP_ENV);
}

// Determine which entry point to import
const { path } = BUILD_TARGETS.find(({ name }) => process.env.REACT_APP_BUILD_TARGET === name);

// Import the entry point and render it's default export
import(`${path}`).then(({ default: BuildTarget }) =>
  // eslint-disable-next-line react/no-render-return-value
  ReactDOM.render(
    <React.StrictMode>
      <BuildTarget />
    </React.StrictMode>,
    document.getElementById('root')
  )
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
